<div class="invoice-list-wrapper">
  <!-- Supplier view -->
  <app-supplier-service-invoices-list *ngIf="isSupplier"></app-supplier-service-invoices-list>

  <!-- Buyer view -->
  <app-buyer-service-invoices-list *ngIf="isBuyer"></app-buyer-service-invoices-list>
</div>
